const initialState = {
    text: '',
    type: 'success',
    duration: 3000,
    textStyle: {},
    timestamp: null
}

const notifications = (state = initialState, action) => {
    switch (action.type) {
        case "UPDATE_POPUP":
            return {
                ...state,
                text: action.toast.text,
                type: action.toast.type ? action.toast.type : 'success',
                duration: action.toast.duration ? action.toast.duration : 3000,
                timestamp: new Date().getTime()
            }
        default:
            return state
    }
}

export default notifications